/**
 * Created by emanuele on 29/01/2017.
 */
/* eslint-disable no-constant-condition */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react'
import {arrayToCombo, optionsStatoGara} from '../../Helpers'

class StatoGaraComboFilter extends Component {
    constructor(props) {
        super(props);
        let fields = {statoGara: props.statoGara}
        this.state = {
            fields: fields,
            dropdownLoading: false,
            dropdownList: [],
        };
        this.onInputChange = this.onInputChange.bind(this);
        this.comboScelte = this.comboScelte.bind(this);
    }
    componentWillReceiveProps(nextProps){
        if (nextProps.statoGara !== this.state.fields.statoGara)
        {
            let fields = this.state.fields;
            fields.statoGara = nextProps.statoGara;
            this.setState({fields},
                ()=>{
                    if ( this.state.fields.statoGara !== undefined){
                        this.props.onChange(
                            this.state.fields.statoGara,
                            this.getDDText(this.state.fields.statoGara, this.state.dropdownList)
                        );
                    }
                });
        }
    }
    componentDidMount(){
        this.comboScelte();
    }

    getDDText(value, options){
        let selectedItem = options.find((it) => {
            return it.value === value;
        })
        return selectedItem ? selectedItem.text : '';
    }

    comboScelte(){  
        let items = [{statoGara: 'ALL', nome: 'Tutte le gare'}];
        items = items.concat(optionsStatoGara.map(value => {return  {statoGara: value.key, nome: value.text}}));
        this.setState(
            {
                dropdownLoading: false,
                error: null,
                dropdownList: arrayToCombo(items, "statoGara", "nome", "statoGara", false)
            },
            ()=>{
            if ( this.state.fields.statoGara !== undefined){
                this.props.onChange(
                    this.state.fields.statoGara,
                    this.getDDText(this.state.fields.statoGara, this.state.dropdownList)
                );
            }
        })
    }

    onInputChange(a1, b1) {

        let name = b1.name;
        let value = b1.value;

        if (name !== undefined)
        {
            const fields = this.state.fields;
            fields[name] = value;
            this.setState({ fields }, () => {
                this.props.onChange(this.state.fields.statoGara, this.getDDText(value, b1.options));
            });

        }
    }

    render() {
        return (
            <div className="ui form">
                    <Form.Field className="fields">
                        <Form.Dropdown width={16} style={{width:"100%"}} placeholder="Stato" name='statoGara' disabled={this.props.abilitato === false} loading={this.state.dropdownLoading} search selection options={this.state.dropdownList} value={this.state.fields.statoGara} onChange={this.onInputChange}/>
                    </Form.Field>
            </div>)
    }
}

StatoGaraComboFilter.PropTypes = {
    statoGara: PropTypes.string.isRequired, 
    abilitato: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

StatoGaraComboFilter.defaultProps = {
    statoGara: '',
    abilitato: false
};
export default StatoGaraComboFilter;



/** WEBPACK FOOTER **
 ** ./src/components/gare/StatoGaraComboFilter.js
 **/